import React, { cloneElement } from 'react';
import cn from 'classnames';
import styles from './CellContent.module.scss';

const CellContent = ({
  containerClassName,
  icon,
  topRowContent,
  bottomRowContent,
  isHighlighted = false,
  isSelected = false,
  contentStyle,
  children,
  renderIndicatorBadge,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(styles.root, containerClassName, {
        [styles.highlighted]: isHighlighted,
        [styles.selected]: isSelected,
      })}
    >
      {icon && cloneElement(icon, { className: styles.icon })}
      {children ? (
        children
      ) : (
        <div className={styles.contentBlock} style={contentStyle}>
          <p className={cn(styles.content)}>{topRowContent}</p>
          {bottomRowContent && (
            <p className={cn(styles.content)}>{bottomRowContent}</p>
          )}
        </div>
      )}
      {typeof renderIndicatorBadge === 'function' &&
        renderIndicatorBadge({ className: styles.indicatorBadge })}
    </div>
  );
};

export default CellContent;
